import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { Icons, IconsTypes } from '@/components/shared/Icons';

interface IRecordingRule {
  ruleKey: string;
  iconName: IconsTypes;
}

const recordingRules: IRecordingRule[] = [
  { ruleKey: 'path-borders', iconName: IconsTypes.PATH_BORDERS },
  { ruleKey: 'equipment-placing', iconName: IconsTypes.EQUIPMENT_PLACING },
  { ruleKey: 'cramped-greenhouse', iconName: IconsTypes.CRAMPED_GREENHOUSE },
  { ruleKey: 'management-instructions', iconName: IconsTypes.MANAGEMENT_INSTRUCTIONS },
];

export const RecordingRules: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <h3 className="!my-[26px] text-xl md:!my-9 md:text-[32px]">
        {t('photo-video-recording.recording-rules.heading')}
      </h3>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {recordingRules.map(({ ruleKey, iconName }) => (
          <div key={ruleKey} className="flex h-[100px] items-center space-x-4 rounded-md bg-white p-4">
            <span className="flex-none">{Icons({ name: iconName })}</span>
            <span className="text-base font-bold">{t(`photo-video-recording.recording-rules.${ruleKey}`)}</span>
          </div>
        ))}
      </div>
    </>
  );
};
